(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["fresh-mega-menu"] && !Shopify.designMode) return;
  try {
    (function () {
    function closeAll(except) {
      document.querySelectorAll('[data-fresh-menu-item]').forEach(function (item) {
        if (item === except) return;
        item.dataset.open = 'false';
        var trigger = item.querySelector('[data-fresh-menu-trigger]');
        var panel = item.querySelector('[data-fresh-menu-panel]');
        if (trigger) trigger.setAttribute('aria-expanded', 'false');
        if (panel) panel.hidden = true;
      });
    }

    document.addEventListener('click', function (e) {
      var trigger = e.target.closest('[data-fresh-menu-trigger]');
      if (trigger) {
        e.stopPropagation();
        var item = trigger.closest('[data-fresh-menu-item]');
        var panel = item.querySelector('[data-fresh-menu-panel]');
        var willOpen = item.dataset.open !== 'true';
        closeAll(willOpen ? item : null);
        item.dataset.open = willOpen ? 'true' : 'false';
        trigger.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
        panel.hidden = !willOpen;
        return;
      }
      if (!e.target.closest('[data-fresh-menu-panel]')) {
        closeAll(null);
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeAll(null);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
